import React, { Component } from "react";
import { connect } from "react-redux";
import { AppointmentSummaryAnimation } from "../../BookingPortal/components/Shared/Animation";
import * as helpers from "./FormFields/formHelpers";
import { appointmentSummarySelector } from "../selectors";
import {
  reloadSteps,
  goToStep,
  goBackToStep,
  toggleControl,
  goToPage,
  updateAppointmentDetail
} from "../../BookingPortal/actions";
import * as STEPS from "../../BookingPortal/consts/stepKeys";

class AppointmentSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseOverItem: ""
    };
  }

  handleStepClick = (e, step) => {
    e.preventDefault();
    const stepIndex = this.props.completedSteps.indexOf(step);
    const previousStep = this.props.completedSteps[stepIndex - 1];
    if (this.props.anyPractitioner) {
      this.props.updateAppointmentDetail(STEPS.PRACTITIONER, "ANY");
    }
    helpers.editStep(this.props, step, previousStep);
    this.props.goToPage("booking");
  };

  handleMouseOverItemChange = key => {
    this.setState({ mouseOverItem: key });
  };

  renderSummaryLinks = () => {
    const {
      specialtyType,
      appointmentType,
      practitioner,
      location,
      appointmentDateTime,
      hideSpecialty,
      hidePractitioner
    } = this.props;

    const links = [
      {
        key: STEPS.SPECIALTY_TYPE,
        text: `${specialtyType} ${appointmentType}`,
        icon: "local_hospital",
        hidden: hideSpecialty
      },
      {
        key: STEPS.PRACTITIONER,
        text: `${practitioner}`,
        icon: "account_box",
        hidden: hidePractitioner
      },
      {
        key: STEPS.LOCATION,
        text: `${location}`,
        icon: "room",
        hidden: false
      },
      {
        key: STEPS.APPOINTMENT_DATE_TIME,
        text: `${appointmentDateTime}`,
        icon: "date_range",
        hidden: false
      }
    ];

    return links.filter(link => !link.hidden).map(link => {
      return (
        <a
          key={link.key}
          style={{ cursor: "pointer" }}
          onClick={e => this.handleStepClick(e, link.key)}
          onMouseOver={() => {
            this.handleMouseOverItemChange(link.key);
          }}
          onMouseOut={() => {
            this.handleMouseOverItemChange("");
          }}
          className="appointment-summary-link"
        >
          {this.state.mouseOverItem === link.key ? (
            <i className="material-icons">mode_edit</i>
          ) : (
            <i className="material-icons">{link.icon}</i>
          )}
          {link.text}
        </a>
      );
    });
  };

  render() {
    return (
      <AppointmentSummaryAnimation>
        <div className="appointment-summary-container">
          <div className="container">
            <div className="appointment-summary-title">MY APPOINTMENT</div>
            {this.renderSummaryLinks()}
          </div>
        </div>
      </AppointmentSummaryAnimation>
    );
  }
}

export default connect(appointmentSummarySelector, {
  reloadSteps,
  goToStep,
  goToPage,
  goBackToStep,
  toggleControl,
  updateAppointmentDetail
})(AppointmentSummary);



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/AppointmentSummary.js